const tinyApi = "lw4bs8ebldtu4nfir9lqek6nqrtqeqkkcmr9mrqpojgef6g5";
const baseApiUrl = "http://192.168.3.28:81";
//const baseApiUrl ='http://192.168.3.12:81';
// const baseApiUrl ='http://185.103.129.111:91';
//const baseApiUrl = "https://localhost:6001";

////////////////////////////////////////////// prod



// const baseApiUrl ='https://api.rasamflexo.ir'
// const baseApiUrl ='http://192.168.3.12:98';
export { baseApiUrl, tinyApi };
//  